import * as v from 'valibot'
import { ALERT_TABLE_TILE_TABS } from '../lib/AlertTableTile/AlertTableTileTabs.ts'
import { ALL_CASE_STEP_FILTER_VALUES } from '../lib/CaseTableTile/CaseTable/CaseStepColumnFilterPopoverUi/caseStepOptions.ts'

export const ALERT_SEARCH_PARAMS_SCHEMA = v.object({
  alertFilterType: v.optional(v.picklist(Object.values(ALERT_TABLE_TILE_TABS))),
  statuses: v.optional(
    v.fallback(
      v.array(v.picklist(ALL_CASE_STEP_FILTER_VALUES)),
      [], // Empty by default, will be set dynamically based on allowed case types
    ),
    [],
  ),
})
